<template>
  <div>
    <v-snackbar
      v-model="dialog.snackbar"
      top
      right
      color="green">
      <span class="body-1 font-weight-light white--text"
        v-html="message.success">
      </span>

      <template v-slot:action="{ attrs }">
        <v-btn
          class="body-1 font-weight-bold text-capitalize"
          color="white"
          icon
          v-bind="attrs"
          @click="dialog.snackbar = false">
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog v-model="dialog.deactive"
      @keydown.esc="dialog.deactive = false"
      :fullscreen="dialog.fullscreen"
      width="500"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          Non Aktif Data

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.deactive = false; dialog.fullscreen = false;"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text 
          class="body-1 font-weight-light text-first mt-3">
          <div 
            class="mb-3">
            <div
              v-if="form.is_active === 'Aktif'">
              Apakah Anda yakin menonaktifkan data <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> ini? Jika iya silahkan isi lampiran & catatan dibawah ini :
            </div>

            <div
              v-else>
              Apakah Anda yakin mengaktifkan data <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> ini?
            </div>
          </div>

          <div v-if="form.is_active === 'Aktif'">
            <div
              class="body-2 mb-2">
              Lampiran
            </div>

            <uploadlamp
              v-model="upload.lamp" 
              style="height: 300px;">
              <div 
                slot="activator"
                class="cursor-pointer">
                <v-card 
                  flat
                  height="300"
                  class="d-flex align-center justify-center"
                  style="border-radius: 15px;
                        border: 2px solid #eaeaea; 
                        border-style: dashed;">
                  <div v-if="form_deactive.is_active_url.length < 1">
                    <v-icon v-if="!process.upload_lamp"
                      size="60" 
                      color="grey">
                      mdi-cloud-upload-outline
                    </v-icon>

                    <v-progress-circular v-else
                      indeterminate
                      :color="set_color">
                    </v-progress-circular>
                  </div>

                  <v-img v-else
                    contain
                    height="300"
                    :src="form_deactive.is_active_url" 
                    :alt="form_deactive.is_active_url"
                    class="text-center d-flex align-center">
                    <div 
                      class="d-flex aling-center justify-center" 
                      style="width: 100%; height: auto;">
                      <v-icon v-if="!process.upload_lamp"
                        size="60" 
                        color="white">
                        mdi-cloud-upload-outline
                      </v-icon>

                      <v-progress-circular v-else
                        indeterminate
                        :color="set_color">
                      </v-progress-circular>
                    </div>
                  </v-img>
                </v-card>
              </div>
            </uploadlamp>

            <div
              class="mt-6">
              <v-textarea
                outlined
                dense
                rows="3"
                hide-details
                :color="set_color"
                placeholder="Contoh. Tulis catatan disini . . ."

                v-uppercase

                v-model="form_deactive.is_active_desc">
              </v-textarea>
            </div>
          </div>
        </v-card-text>

        <div v-if="message.error.length > 0"
          class="text-center mx-6 my-4">
          <div
            class="error--text d-flex align-center">
            <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
            
            <span
              class="ml-1">
              {{ message.error }}
            </span>
          </div>
        </div>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="green"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.deactive"
            :loading="process.deactive"
            @click="deactived()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Ya, {{ form.is_active === 'Aktif' ? 'Non Aktif' : 'Aktif' }}
          </v-btn>

          <v-btn
            outlined
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.deactive"
            @click="dialog.deactive = false; dialog.fullscreen = false;">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <section>
      <ValidationObserver 
        ref="form">
        <v-form>
          <div 
            class="title font-weight-bold black--text mb-6"
            style="opacity: 70%;">
            #Biodata Abdi Dalem
          </div>
          
          <v-row
            style="min-height: 64.6vh;">
            <v-col 
              cols="12" 
              md="6"
              class="py-0">
              <div
                class="mb-6">
                <div class="body-2 mb-2">
                  Gambar Profil
                  <!-- <span>
                    (boleh dikosongi)
                  </span> -->
                </div>

                <uploadfolder v-model="upload.folder"
                  style="width: 200px; height: 200px;">
                  <div 
                    slot="activator" 
                    class="cursor-pointer">
                    <v-card 
                      flat
                      width="200"
                      height="200"
                      class="d-flex align-center justify-center"
                      style="border-radius: 15px;
                            border: 2px solid #eaeaea; 
                            border-style: dashed;">
                      <v-img v-if="!process.image && form.image_url !== ''"
                        alt="kominfo" 
                        width="196"
                        height="196"
                        gradient="to bottom, rgba(0, 0, 0, .1), rgba(0, 0, 0, .5)"
                        :src="form.image_url"
                        class="ma-auto d-flex align-center text-center">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>

                        <v-icon 
                          size="50" 
                          color="white">
                          mdi-cloud-upload-outline
                        </v-icon>
                      </v-img>

                      <v-icon v-if="!process.image && form.image_url === ''"
                        size="50" 
                        color="grey">
                        mdi-cloud-upload-outline
                      </v-icon>

                      <v-progress-circular v-if="process.image"
                        indeterminate
                        :color="set_color">
                      </v-progress-circular>
                    </v-card>
                  </div>
                </uploadfolder>
              </div>

              <ValidationProvider 
                name="code" 
                rules="required|min:16|max:16" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  <!-- Nomor Induk -->
                  Nomor Induk Kependudukan
                  <!-- <span class="error--text">
                    (wajib diisi)
                  </span> -->
                </div>
                
                <v-text-field
                  v-on:keyup.enter="save"
                  :style="`width: ${rps === 'xs' ? 100 : 60}%`"
                  class="mb-6"
                  filled
                  rounded
                  dense
                  :color="set_color"
                  placeholder="Contoh. 3310062008XXXXXX"
                  hide-details

                  type="number"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  min="0"

                  @keyup="check_nik()"
                  @blur="check_nik()"

                  v-uppercase

                  v-model="form.code"
                  :success="valid && message.field.length < 1"
                  :error-messages="errors || message.field.length > 0"
                  required
                  style="border-radius: 10px">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0 || message.field.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        <!-- Nomor Induk {{ errors[0] }} -->
                        Nomor Induk Kependudukan {{ errors[0] }} {{ message.field }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.code !== '' && valid && message.field.length < 1">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>

              <div
                class="mb-6">
                <div class="body-2 mb-2">
                  Upload Nomor Induk Kependudukan
                  <!-- <span>
                    (boleh dikosongi)
                  </span> -->
                </div>

                <v-card
                  width="400"
                  flat
                  height="250">
                  <v-btn
                    @click="form.nik_url = ''"
                    v-if="form.nik_url !== ''"
                    icon
                    style="position: absolute; top: -15px; right: -15px; z-index: 1;">
                    <v-icon
                      color="red">
                      mdi-close-circle
                    </v-icon>
                  </v-btn>
                  <uploadfolder v-model="upload.folder_nik"
                    style="width: 400px; height: 250px;">
                    <div 
                      slot="activator" 
                      class="cursor-pointer">
                      <v-card 
                        flat
                        width="400"
                        height="250"
                        class="d-flex align-center justify-center"
                        style="border-radius: 15px;
                              border: 2px solid #eaeaea; 
                              border-style: dashed;">
                        <v-img v-if="!process.image_nik && form.nik_url !== ''"
                          alt="kominfo" 
                          width="396"
                          height="246"
                          gradient="to bottom, rgba(0, 0, 0, .1), rgba(0, 0, 0, .5)"
                          :src="form.nik_url"
                          class="ma-auto d-flex align-center text-center">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
  
                          <v-icon 
                            size="50" 
                            color="white">
                            mdi-cloud-upload-outline
                          </v-icon>
                        </v-img>
  
                        <v-icon v-if="!process.image_nik && form.nik_url === ''"
                          size="50" 
                          color="grey">
                          mdi-cloud-upload-outline
                        </v-icon>
  
                        <v-progress-circular v-if="process.image_nik"
                          indeterminate
                          :color="set_color">
                        </v-progress-circular>
                      </v-card>
                    </div>
                  </uploadfolder>
                </v-card>

              </div>
            </v-col>

            <v-col 
              cols="12" 
              md="6"
              class="py-0">
              <ValidationProvider 
                name="name" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  Nama Lengkap
                  <!-- <span>
                    (boleh dikosongi)
                  </span> -->
                </div>
                
                <v-text-field
                  v-on:keyup.enter="save"
                  :style="`width: ${rps === 'xs' ? 100 : 70}%`"
                  class="mb-6"
                  filled
                  rounded
                  dense
                  :color="set_color"
                  placeholder="Contoh. John Doe"
                  hide-details
                  clearable
                  @click:clear="form.name = ''"
                  v-uppercase

                  v-model="form.name"
                  :success="valid"
                  :error-messages="errors"
                  required
                  style="border-radius: 10px">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Nama Lengkap {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.name !== '' && valid && form.name !== null">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>

              <ValidationProvider 
                name="category" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  Kategori
                  <!-- <span>
                    (boleh dikosongi)
                  </span> -->
                </div>

                <v-autocomplete
                  v-on:keyup.enter="save"
                  :style="`width: ${rps === 'xs' ? 100 : 50}%`"
                  class="mb-6"
                  filled
                  rounded
                  dense
                  :color="set_color"
                  placeholder="Contoh. SENTANA"
                  hide-details
                  clearable
                  @click:clear="form.category = ''"
                  
                  :items="['ABDI DALEM', 'SENTANA']"
                  item-text="text"
                  item-value="value"
                  :item-color="set_color"
                  v-on:change="form.category === 'SENTANA' ? '' : form.trah_id = ''; form.trah_status_id = '';"
                  v-model="form.category"
                  :success="form.category !== '' && valid"
                  :error-messages="errors"
                  style="border-radius: 10px">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Kategori {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.category !== '' && valid && form.category !== null">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-autocomplete>
              </ValidationProvider>

              <ValidationProvider 
                name="unit" 
                :rules="form.category === 'SENTANA' ? '' : 'required'" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span v-if="form.category !== 'SENTANA'" class="red--text">*</span>
                  Kawedanan
                  <!-- <span class="error--text">
                    (wajib diisi)
                  </span> -->
                </div>

                <v-autocomplete
                  v-on:keyup.enter="save"
                  :style="`width: ${rps === 'xs' ? 100 : 70}%`"
                  class="mb-6"
                  filled
                  rounded
                  dense
                  :color="set_color"
                  placeholder="Contoh. KAWEDANANAN KAKRABATANI"
                  hide-details
                  clearable
                  @click:clear="form.unit = ''"
                  
                  :items="list"
                  item-text="name"
                  item-value="id"
                  :item-color="set_color"

                  @change="form.seksi = []; form.seksi_string = '';"

                  v-uppercase

                  v-model="form.unit"
                  :success="form.unit !== '' && valid"
                  :error-messages="errors"
                  style="border-radius: 10px">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Kawedanan {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.unit !== '' && valid && form.unit !== null">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-autocomplete>
              </ValidationProvider>

              <ValidationProvider 
                name="seksi" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <!-- Seksi -->
                  Urusan
                  <!-- <span class="error--text">
                    (wajib diisi)
                  </span> -->
                </div>

                <!-- <v-select
                  v-on:keyup.enter="save"
                  :style="`width: ${rps === 'xs' ? 100 : 70}%`"
                  class="mb-6"
                  filled
                  rounded
                  dense
                  :color="set_color"
                  placeholder="Contoh. SEKSI KEPRAJURITAN"
                  hide-details
                  
                  :items="sub_list"
                  item-text="name"
                  item-value="id"
                  :item-color="set_color"

                  multiple

                  v-uppercase

                  v-model="form.seksi"
                  :success="form.seksi.length > 0 && valid"
                  :error-messages="errors"
                  style="border-radius: 10px">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Urusan {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.seksi.length > 0 && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-select> -->


                <v-autocomplete
                  v-on:keyup.enter="save"
                  :style="`width: ${rps === 'xs' ? 100 : 70}%`"
                  class="mb-6"
                  filled
                  rounded
                  dense
                  :color="set_color"
                  placeholder="Contoh. SEKSI KEPRAJURITAN"
                  hide-details
                  clearable
                  @click:clear="form.seksi_string = ''"
                  
                  :items="sub_list"
                  item-text="name"
                  item-value="id"
                  :item-color="set_color"

                  v-uppercase

                  v-model="form.seksi_string"
                  :success="form.seksi_string.length > 0 && valid"
                  :error-messages="errors"
                  style="border-radius: 10px">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        <!-- Seksi {{ errors[0] }} -->
                        Urusan {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.seksi_string.length > 0 && valid && form.seksi_string !== null">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-autocomplete>
              </ValidationProvider>


              <v-row v-if="form.category === 'SENTANA'">
                <v-col cols="12" md="6" class="py-0">
                  <ValidationProvider 
                    name="trah" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      Trah
                      <!-- <span>
                        (boleh dikosongi)
                      </span> -->
                    </div>

                    <v-autocomplete
                      v-on:keyup.enter="save"
                      class="mb-6"
                      filled
                      rounded
                      dense
                      :color="set_color"
                      placeholder="Contoh. Pakualaman 1"
                      hide-details
                      clearable
                      @click:clear="form.trah_id = '';"
                      
                      :items="trah"
                      item-text="name"
                      item-value="id"
                      :item-color="set_color"

                      v-model="form.trah_id"
                      :success="form.trah_id !== '' && valid"
                      :error-messages="errors"
                      style="border-radius: 10px">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            Trah {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.trah_id !== '' && valid && form.trah_id !== null">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-autocomplete>
                  </ValidationProvider>
                </v-col>

                <v-col cols="12" md="6" class="py-0">
                  <ValidationProvider 
                    name="status trah" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      Status Trah
                      <!-- <span>
                        (boleh dikosongi)
                      </span> -->
                    </div>

                    <v-autocomplete
                      v-on:keyup.enter="save"
                      class="mb-6"
                      filled
                      rounded
                      dense
                      :color="set_color"
                      placeholder="Contoh. Putra"
                      hide-details
                      
                      :items="status_trah"
                      item-text="name"
                      item-value="id"
                      :item-color="set_color"
                      clearable
                      @click:clear="form.trah_status_id = '';"

                      v-model="form.trah_status_id"
                      :success="form.trah_status_id !== '' && valid"
                      :error-messages="errors"
                      style="border-radius: 10px">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            Status Trah {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.trah_status_id !== '' && valid && form.trah_status_id !== null">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-autocomplete>
                  </ValidationProvider>
                </v-col>
              </v-row>

              <ValidationProvider 
                name="status" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  Status
                  <!-- <span>
                    (boleh dikosongi)
                  </span> -->
                </div>

                <v-autocomplete
                  v-on:keyup.enter="save"
                  :style="`width: ${rps === 'xs' ? 100 : 40}%`"
                  class="mb-6"
                  filled
                  rounded
                  dense
                  :color="set_color"
                  placeholder="Contoh. TEPAS"
                  hide-details
                  clearable
                  @click:clear="form.status = ''"
                  
                  :items="['TEPAS', 'CAOS']"
                  item-text="text"
                  item-value="value"
                  :item-color="set_color"

                  v-model="form.status"
                  :success="form.status !== '' && valid"
                  :error-messages="errors"
                  style="border-radius: 10px">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Status {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.status !== '' && valid && form.status !== null">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-autocomplete>
              </ValidationProvider>

              <v-row>
                <v-col
                  cols="12"
                  md="5"
                  class="py-0">
                  <div>
                    <div class="body-2 mb-2">
                      Mulai Aktif
                      <!-- <span>
                        (boleh dikosongi)
                      </span> -->
                    </div>

                    <v-menu
                      ref="join_date"
                      min-width="290px"
                      max-width="290px"
                      transition="scale-transition"
                      offset-y
                      :nudge-right="40"
                      :close-on-content-click="false"
                      v-model="picker">
                      <template v-slot:activator="{ on, attrs }">
                        <ValidationProvider 
                          name="join_date" 
                          v-slot="{ errors, valid }">
                          <v-text-field
                            class="mb-6"
                            readonly
                            filled
                            rounded
                            dense
                            :color="set_color"
                            placeholder="2023-01-01"
                            hide-details
                            clearable
                            @click:clear="form.join_date = ''"

                            v-uppercase

                            v-model="form.join_date"
                            v-on="on"
                            v-bind="attrs"
                            :success="form.join_date !== '' && valid"
                            :error-messages="errors"
                            style="border-radius: 10px;">
                            <template v-slot:append-outer>
                              <div v-if="errors.length > 0">
                                <v-tooltip top color="#ff5252">
                                  <template v-slot:activator="{ on }">
                                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                  </template>
                                  
                                  Mulai Aktif {{ errors[0] }}
                                </v-tooltip>
                              </div>

                              <div v-if="form.join_date !== '' && valid">
                                <v-icon color="success">mdi-check-circle-outline</v-icon>
                              </div>
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </template>

                      <v-date-picker 
                        :color="set_color"
                        v-model="form.join_date"
                        @input="picker = false">
                      </v-date-picker>
                    </v-menu>
                  </div>
                </v-col>

                <v-col
                  cols="12"
                  md="7"
                  class="py-0">
                  <div class="body-2 mb-4">
                    #Lama Mengabdi
                  </div>

                  <div
                    class="body-1 font-weight-bold"
                    :class="form.lama_mengabdi === 'Belum diketahui' ? 'orange--text' : ''">
                    {{ form.lama_mengabdi }}
                  </div>
                </v-col>
              </v-row>

              <!-- <div>
                <div class="body-2 mb-2">
                  Mulai Aktif
                  <span>
                    (boleh dikosongi)
                  </span>
                </div>

                <v-menu
                  ref="join_date"
                  min-width="290px"
                  max-width="290px"
                  transition="scale-transition"
                  offset-y
                  :nudge-right="40"
                  :close-on-content-click="false"
                  v-model="picker">
                  <template v-slot:activator="{ on, attrs }">
                    <ValidationProvider 
                      name="join_date" 
                      v-slot="{ errors, valid }">
                      <v-text-field
                        :style="`width: ${rps === 'xs' ? 100 : 35}%`"
                        class="mb-6"
                        readonly
                        filled
                        rounded
                        dense
                        :color="set_color"
                        placeholder="2023-01-01"
                        hide-details
                        clearable
                        @click:clear="form.join_date = ''"

                        v-uppercase
                        
                        v-model="form.join_date"
                        v-on="on"
                        v-bind="attrs"
                        :success="form.join_date !== '' && valid"
                        :error-messages="errors"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Mulai Aktif {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.join_date !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </template>

                  <v-date-picker 
                    :color="set_color"
                    v-model="form.join_date"
                    @input="picker = false">
                  </v-date-picker>
                </v-menu>
              </div> -->
            </v-col>
          </v-row>
        </v-form>

        <div v-if="message.error.length > 0"
          class="text-center my-4">
          <div
            class="error--text d-flex align-center">
            <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
            
            <span
              class="ml-1">
              {{ message.error }}
            </span>
          </div>
        </div>
      </ValidationObserver>

      <div>
        <v-divider 
          class="mb-4" 
          style="border: 3px solid #f0f0f0; border-radius: 50px;"/>

        <v-card-actions> 
          <div v-if="form.id !== undefined"
            class="mr-4">
            <div>
              Status Abdi Dalem: <strong>{{ form.is_active }}</strong>
            </div>

            <div>
              Ubah <span class="font-italic">"klik tombol disamping"</span>.
            </div>
          </div>

          <v-btn v-if="form.id !== undefined"
            @click="toDeactive()"
            :color="form.is_active === 'Aktif' ? 'orange' : '#00bcd4'"
            elevation="0"
            class="body-2 font-weight-bold white--text text-capitalize"
            style="border-radius: 10px;">
            <v-icon small class="mr-1">
              {{
                form.is_active === 'Aktif' ? 'mdi-swap-horizontal-circle-outline' : 'mdi-check-circle-outline'
              }}
            </v-icon>

            {{
              form.is_active === 'Aktif' ? 'Non Aktif' : 'Aktif'
            }}
          </v-btn>

          <v-spacer/>

          <v-btn v-if="form.id !== undefined"
            :disabled="process.print"
            :loading="process.print"
            @click="prints()"
            :color="set_color"
            elevation="0"
            class="body-2 font-weight-bold white--text text-capitalize"
            style="border-radius: 10px;">
            <v-icon small class="mr-1">mdi-microsoft-excel</v-icon>

            Print
          </v-btn>

          <v-btn
            :disabled="process.form || message.field.length > 0"
            :loading="process.form"
            v-on:keyup.enter="save()"
            @click="save()"
            color="green"
            elevation="0"
            class="body-2 font-weight-bold white--text text-capitalize"
            style="border-radius: 10px;">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>

            Simpan
          </v-btn>

          <router-link
            to="/officer">
            <v-btn
              outlined
              class="body-2 font-weight-bold text-capitalize red--text px-2 ml-2"
              :disabled="process.form"
              style="border-radius: 10px;">
              <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>

              Batal
            </v-btn>
          </router-link>
        </v-card-actions>
      </div>
    </section>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import { TokenService } from "@/service/Storage.Service";
  import axios from "axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    props: {
      form: {
        type: Object,
        default: {}
      }
    },
    data () {
      return {
        dialog: {
          snackbar: false,
          fullscreen: false,
          deactive: false
        },
        picker: false,
        upload: {
          folder: null,
          folder_nik: null,
          lamp: null
        },
        trah: [],
        status_trah: [],
        list: [],
        sub_list: [],
        process: {
          form: false,
          image: false,
          image_nik: false,
          load: false,
          sub: false,
          print: false,

          upload_lamp: false,
          deactive: false
        },

        form_deactive: {
          id: '',
          is_active_desc: '',
          is_active_url: ''
        },

        message: {
          success: '',
          error: '',
          field: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetch: true */ '@/components/upload/folder.vue'),
      uploadlamp: () => import(/* webpackPrefetch: true */ '@/components/upload/folder.vue')
    },
    watch: {
      'form.code': function (val) {
        this.form.nik = val
      },
      'form.unit': function () {
        this.fetchSub()
      },
      'upload.folder': {
        handler: function () {
          if (this.upload.folder) {
            this.process.image = this.upload.folder.process

            if (!this.process.image) {
              // CALLBACK FROM UPLOAD IMAGE

              this.form.image_url = this.upload.folder.fileuri
            }
          }
        },
        deep: true
      },
      'upload.folder_nik': {
        handler: function () {
          if (this.upload.folder_nik) {
            this.process.image_nik = this.upload.folder_nik.process

            if (!this.process.image_nik) {
              // CALLBACK FROM UPLOAD IMAGE

              this.form.nik_url = this.upload.folder_nik.fileuri
            }
          }
        },
        deep: true
      },

      'upload.lamp': {
        handler: function () {
          if (this.upload.lamp) {
            this.process.upload_lamp = this.upload.lamp.process

            if (!this.process.upload_lamp) {
              // CALLBACK FROM UPLOAD IMAGE

              this.form_deactive.is_active_url = this.upload.lamp.fileuri
            }
          }
        },
        deep: true
      },

      'form.seksi_string': function (val) {
        this.form.seksi = []

        if (val.length > 0) this.form.seksi.push(val)
      }
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      set_color () {
        return this.$store.state.color
      }
    },
    mounted () {
      this.fetch()
      this.fetchTrah()
      this.fetchTrahStatus()
    },
    methods: {
      async fetch () {
        this.process.load = true

        let params = {
          // parent_id: 3
        }

        await get('admin/unit', { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.status === 200) {
            // this.list = res.results.data

            let data = res.results.data
            data.map(obj => {
              if (parseInt(obj.parent_id) === 0 || parseInt(obj.parent_id) === 1 || parseInt(obj.parent_id) === 3) {
                this.list.push({
                  id: obj.id,
                  name: obj.name
                })
              }
            })

            this.list.reverse()

            if (this.$route.params.id === undefined) this.check_nik()

            if (this.form.unit.length > 0) this.fetchSub()
          }
        })
      },
      async fetchSub () {
        this.process.sub = true

        let params = {
          parent_id: this.form.unit
        }

        await get('admin/unit', { params })
        .then(response => {
          let res = response.data

          this.process.sub = false
            
          if (res.status === 200) {
            this.sub_list = res.results.data
          }
        })
      },
      async fetchTrah () {
        this.process.load = true

        let params = {
          // parent_id: this.form.unit
        }

        await get('admin/trah/data', { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.status === 200) {
            this.trah = res.results.data
          }
        })
      },
      async fetchTrahStatus () {
        this.process.load = true

        let params = {
          // parent_id: this.form.unit
        }

        await get('admin/trah_status/data', { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.status === 200) {
            this.status_trah = res.results.data
          }
        })
      },
      async save () {
        this.message.error = ''
        
        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          let forms = Object.assign({}, this.form)
          forms.seksi = JSON.stringify(forms.seksi)
          
          if (this.$route.params.id === undefined) {
            await post(`admin/user/add`, {
              data: forms
            })
            .then((response) => {
              let res = response.data
  
              if (res.status === 200) {
                this.$router.push({ path: `/officer/form/edit/${res.results.data.id}`, query: { step: 1 }})

                this.process.form = false

                this.dialog.snackbar = true
                this.message.success = res.message
              } else {
                this.process.form = false
                this.message.error = res.message
              }
            })
          } else {
            await post(`admin/user/update`, {
              data: forms
            })
            .then((response) => {
              let res = response.data
  
              if (res.status === 200 ) {
                this.$emit('load', true)
                
                this.process.form = false

                this.dialog.snackbar = true
                this.message.success = res.message
              } else {
                this.process.form = false
                this.message.error = res.message
              }
            })
          }
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      // CEK NIK
      async check_nik () {
        this.message.field = ''

        await post('lib/ktp', {
          data: {
            ktp: this.form.nik
          }
        })
        .then(response => {
          let res = response.data

          if (res.status === 400) {
            this.message.field = res.message
          }
        })
      },

      // PRINT
      async prints () {
        this.message.error = ''

        this.process.print = true

        let params = {
          id: this.form.id
        }

        await axios({
          url: `${process.env.VUE_APP_API_URL}admin/user/export_individu`,
          method: 'GET',
          responseType: 'blob', // important,
          params: params,
          headers: {
            Authorization: process.env.VUE_APP_XAUTH,
            token: TokenService.getToken()
          }
        }).then((response) => {
          let res = response

          if (res.status === 200) {
            this.process.print = false
            
            this.dialog.snackbar = true
            this.message.success = 'Berhasil mengeksport excel'

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            // console.log(response.headers['Content-Disposition'])
            
            link.href = url
            link.setAttribute('download', `Amanata-${moment().format('DD-MMMM-YYYY', 'id')}-${moment().format('HH:mm:ss', 'id')}.pdf`)
            document.body.appendChild(link)
            link.click()
          } else {
            this.process.print = false
            this.message.error = res.message
          }
        })
      },

      // NON AKTIF
      async fetchDetail () {
        let params = {
          id: this.$route.params.id
        }

        await get(`admin/user/detail`, { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            let item = res.results.data

            this.form = {
              id: item.id,
              // BIODATA
              image_url: item.image_url,
              code: item.code,
              name: item.name,
              role: item.role,
              kalenggahan: item.kalenggahan,
              kalenggahan_name: item.kalenggahan_name,
              urusan: item.urusan,
              category: item.category,
              status: item.status,
              join_date: item.join_date,
              
              
              // unit: [],
              unit: item.kawedanan[0].id,
              seksi: [],
              seksi_string: '',

              // PERSONAL
              nik: item.nik,
              nik_url: item.nik_url,
              kk: item.kk,
              kk_url: item.kk_url,
              birthplace: item.birthplace,
              birthdate: item.birthdate,
              gender: item.gender,
              ktp_address: item.ktp_address,
              domicile_address: item.domicile_address,
              religion: item.religion,
              blood_group: item.blood_group,
              last_education: item.last_education,
              degree_education: item.degree_education,
              profession: item.profession,
              mobilephone: item.mobilephone,
              wa_number: item.wa_number,
              email: item.email,
              marital_status: item.marital_status,

              // PAKAIAN
              ukuran_kaos: item.ukuran_kaos,
              ukuran_blangkon: item.ukuran_blangkon,
              ukuran_selop: item.ukuran_selop,
              ukuran_pranakan: item.ukuran_pranakan,
              ukuran_atela: item.ukuran_atela,

              // LAINNYA
              norek_danais: item.norek_danais,
              tgl_awal_terima_danais: item.tgl_awal_terima_danais,
              kop_join_date: item.kop_join_date,
              bpjs_jenis: item.bpjs_jenis,
              job_other: item.job_other,

              npwp: item.npwp,
              emergency_number: item.emergency_number,
              emergency_number_name: item.emergency_number_name,

              asuransi_kes: item.asuransi_kes,
              nomor_polis_asuransi: item.nomor_polis_asuransi,
              asuransi_status: item.asuransi_status,
              catatan_kesehatan: item.catatan_kesehatan,

              // EXTRA
              lama_mengabdi: item.lama_mengabdi === undefined ? 'Belum diketahui' : item.lama_mengabdi,
              age: item.age === undefined ? 'Belum diketahui' : item.age,

              is_active: item.is_active
            }

            if (item.seksi !== undefined && item.seksi.length > 0) {
              item.seksi.map(obj => {
                this.form.seksi.push(obj.id)
              })

              this.form.seksi_string = item.seksi[0].id
            }
          }
        })
      },
      toDeactive () {
        this.form_deactive = {
          id: this.$route.params.id,
          is_active_desc: '',
          is_active_url: ''
        }

        this.dialog.deactive = true
      },
      async deactived () {
        this.message.error = ''

        this.process.deactive = true

        let url = this.form.is_active === 'Aktif' ? 'admin/user/deactivate' : 'admin/user/activate'
        
        await post(url, {
          data: this.form_deactive
        })
        .then((response) => {
          let res = response.data

          if (res.status === 200) {
            this.process.deactive = false

            this.dialog.deactive = false

            this.dialog.snackbar = true
            this.message.success = res.message

            this.fetchDetail()
          } else {
            this.process.deactive = false
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>